import {storeRefreshToken} from '~/lib/auth/refresh-token-storage';
import {request} from './client';
import type {VerifyConfirmResponse, VerifyRequestResponse} from './types';

export function requestOtp(
  identifier: string,
  email: string,
): Promise<VerifyRequestResponse> {
  return request<VerifyRequestResponse>(identifier, '/sharing/verify/request', {
    method: 'POST',
    body: {identifier, email},
  });
}

export async function confirmOtp(
  identifier: string,
  email: string,
  code: string,
): Promise<VerifyConfirmResponse> {
  const response = await request<VerifyConfirmResponse>(
    identifier,
    '/sharing/verify/confirm',
    {
      method: 'POST',
      body: {identifier, email, code},
    },
  );

  storeRefreshToken(
    identifier,
    response.data.organization_identifier,
    response.data.refresh_token,
    response.data.refresh_token_expires_at,
    {anonymous: false},
  );

  return response;
}
